export default (seconds) => Math.floor(seconds / 60)
